import React, { useState } from "react";
import { CommunityFeedType } from "../../types";
import { DiscussEditUpdate } from "..";
import { useMutation } from "@apollo/client";
import { UPDATE_COMMUNITY_FEED } from "../../apollo/operations";
import { convertToCssColor } from "../../utils/formatColorCode";
import { handleIPFSUploads } from "../../utils/iPfsUpload";

type DiscussContentProps = {
  content?: string;
  editContent: boolean;
  setEditContent: React.Dispatch<React.SetStateAction<boolean>>;
  feedImage: string[];
  communityFeed: CommunityFeedType | undefined;
  feedVideo: string[];
  refetch?: () => void;
  isLocked: boolean | (() => void);
  toggle: boolean | (() => void);
};
const DiscussContent: React.FC<DiscussContentProps> = ({
  content,
  editContent,
  setEditContent,
  communityFeed,
  feedImage,
  feedVideo,
  refetch,
  isLocked,
  toggle,
}) => {
  const maxLength = 400;
  const [isExpanded, setIsExpanded] = React.useState(false);
  const backgroundColors = communityFeed?.feedBackground || "";
  const [updateFeedContent, setUpdateFeedContent] = React.useState(
    communityFeed?.content
  );
  const [imageUploadLoading, setImageUploadLoading] = React.useState(false);
  const [imageCID, setImageCID] = useState<any[]>(feedImage);
  const [compressedVideoCid, setCompressedVideoCid] = useState(feedVideo);
  const [onChange, setOnChange] = React.useState(false);
  const backgroundColor = convertToCssColor(backgroundColors);
  const [thumbFile, setThumbFile] = React.useState<File[]>([]);
  const [compressedVideosArray, setCompressedVideosArray] = React.useState<
    File[]
  >([]);
  const [disableButton, setDisableButton] = useState(false);

  const [updateCommunityFeed, { loading }] = useMutation(
    UPDATE_COMMUNITY_FEED,
    {
      onCompleted(data) {
        console.log(data, "updated");
        if (refetch) {
          refetch();
          // console.log("refreshed");
        }
        setImageUploadLoading(false);
        setDisableButton(false);
      },
      onError: (err) => {
        console.log(err);
        const errorMessage = err.graphQLErrors[0]?.extensions?.originalError;
        console.log(errorMessage);
      },
    }
  );

  // console.log("onChange", onChange);  id: communityFeed?.id,     if (communityFeed?.creator.id) {

  const handleUpdateFeed = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (communityFeed?.creator.id) {
      if (onChange === false) {
        console.log("return it is empty");

        return;
      }
      setImageUploadLoading(true);
      setDisableButton(true);
      setOnChange(false);
      const ipfsVideo = compressedVideosArray.map((video, index) =>
        handleIPFSUploads([video, thumbFile[index]]).then((hashes) => {
          if (hashes && hashes.length === 2) {
            return `${hashes[0]} ${hashes[1]}`;
          } else {
            throw new Error("Failed to upload video or thumbnail to IPFS");
          }
        })
      );

      await Promise.all(ipfsVideo).then((fiteredVideo) => {
        updateCommunityFeed({
          variables: {
            data: {
              content: updateFeedContent,
              mediaUrl: {
                imageUrl: [...imageCID],
                videoUrl: [...compressedVideoCid, ...fiteredVideo],
              },
            },
            where: {
              id: communityFeed?.id,
            },
          },
        }).finally(() => {
          setEditContent(false);
          // setImageCID([]);
          setCompressedVideoCid([]);
          setOnChange(false);
          if (typeof toggle === "function") {
            toggle();
          }
        });
      });
    } else {
      console.log("error updating");
    }
  };

  return (
    <>
      {!editContent && !loading ? (
        feedVideo?.length || feedImage?.length ? (
          <div className="w-[98%] block lg:md:whitespace-pre-line text-black whitespace-pre-line p-1 px-4 break-words text-justify font-SegoeUI mb-2 gap-2 text-sm font-light">
            {content && content.length <= maxLength
              ? content
              : isExpanded
              ? content
              : content?.slice(0, maxLength)}
            {content && content.length > maxLength && (
              <span
                className="cursor-pointer font-extralight text-[10px] pl-2 font-SegoeUI text-greyText"
                onClick={() => setIsExpanded(!isExpanded)}
              >
                {!isExpanded ? " ... See more" : " ... See less"}
              </span>
            )}
          </div>
        ) : (
          <div
            className={`w-[98%] block whitespace-pre-line break-words text-start font-SegoeUI gap-2 px-4 
            ${
              content && content.length > 100
                ? `${
                    backgroundColor.length === 0
                      ? `p-1 text-base font-normal h-auto mb-7`
                      : "p-5 text-base font-normal h-auto mb-7"
                  }`
                : `  ${
                    backgroundColor.length === 0
                      ? "py-16 h-full font-medium lg:md:px-[52px] px-11 lg:text-2xl text-lg mb-7"
                      : "py-[100px] h-full font-medium lg:md:px-[52px] px-11 lg:text-2xl text-lg mb-7"
                  }  `
            }
        `}
            style={{ background: backgroundColor }}
            key={content}
          >
            {content && content.length <= maxLength
              ? content
              : isExpanded
              ? content
              : content?.slice(0, maxLength)}
            {content && content.length > maxLength && (
              <span
                className="cursor-pointer font-extralight text-[10px] pl-2 font-SegoeUI text-greyText"
                onClick={() => setIsExpanded(!isExpanded)}
              >
                {!isExpanded ? "... See more" : "... See less"}
              </span>
            )}
          </div>
        )
      ) : (
        editContent &&
        isLocked && (
          <DiscussEditUpdate
            setUpdateFeedContent={setUpdateFeedContent}
            setEditContent={setEditContent}
            loading={loading}
            handleUpdateFeed={handleUpdateFeed}
            feedImage={feedImage}
            communityFeed={communityFeed}
            updateFeedContent={updateFeedContent}
            backgroundColor={backgroundColor}
            toggle={toggle}
            imageUploadLoading={imageUploadLoading}
            setImageCID={setImageCID}
            imageCID={imageCID}
            compressedVideoCid={compressedVideoCid}
            setCompressedVideoCid={setCompressedVideoCid}
            feedVideos={feedVideo}
            setOnChange={setOnChange}
            onChange={onChange}
            setCompressedVideosArray={setCompressedVideosArray}
            setThumbFile={setThumbFile}
            disableButton={disableButton}
          />
        )
      )}
    </>
  );
};

export default DiscussContent;
